import React from 'react'

import { sanitizeHtml } from '../../lib/helpers/miscHelpers'

type Props<ElementType extends React.ElementType> = {
  html: string
  as?: ElementType
} & Omit<
  React.ComponentProps<ElementType>,
  'children' | 'dangerouslySetInnerHTML'
>

const SanitizedHtml = <ElementType extends React.ElementType = 'div'>({
  html,
  as,
  ...props
}: Props<ElementType>) => {
  const Component = as || 'div'

  return (
    <Component
      {...props}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  )
}

export default SanitizedHtml
